import { useMemo } from 'react';
import { PreviewImage } from 'content-management-details-lib/components/ContentPreviewImage';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { jsx as _jsx } from "react/jsx-runtime";
const HubShotScreenshotQuery = registerQuery({
  fieldName: 'hubShotScreenshots',
  fetcher: ({
    url
  }) => {
    return http.post('hubshot/v3/screenshots/bytes', {
      data: {
        targetUrl: url,
        userAgent: 'HubSpot Content Details'
      }
    }).then(({
      screenshots,
      statusCode
    }) => {
      if (statusCode === 200) {
        const [{
          bytes
        }] = screenshots; // bytes are formatted in `base64`
        return `data:image/png;base64,${bytes}`; // converts base64 to img src
      }
    });
  }
});
const useHubShotScreenshot = ({
  url
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(HubShotScreenshotQuery, {
    variables: {
      url
    }
  });
  return useMemo(() => ({
    screenshotUrl: data === null || data === void 0 ? void 0 : data.hubShotScreenshots,
    screenshotUrlLoading: loading,
    screenshotUrlError: error || !loading && !(data !== null && data !== void 0 && data.hubShotScreenshots)
  }), [data, loading, error]);
};
const ExternalPageHeaderUrlPreviewScreenshot = ({
  url,
  title
}) => {
  const {
    screenshotUrl,
    screenshotUrlLoading
  } = useHubShotScreenshot({
    url
  });
  return /*#__PURE__*/_jsx(PreviewImage, {
    name: title,
    previewUrl: url,
    screenshotUrl: screenshotUrl,
    screenshotUrlLoading: screenshotUrlLoading
  });
};
export default ExternalPageHeaderUrlPreviewScreenshot;